import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putTaskReopen = async ({ taskId }: JsonDataItem) => {
  const data = await baseQuery('task/reopen', {
    type: 'PUT',
    body: {
      task_id: taskId,
    },
  });

  return data;
};
